import styled from 'styled-components';

import {
  getColor,
  getFontSize,
  getLineHeight,
} from '../../styles/themeGetters';

const segmentControlGap = 10;

// Hide the radio buttons and switch segments by clicking on the radio labels
export const SegmentedRadioControl = styled.input`
  height: 0;
  width: 0;
  display: block;
  position: absolute;
`;

export const SegmentedControlSlide = styled.div<{ position: number }>`
  flex: 1;
  height: 100%;
  background: ${getColor('white')};

  /* The formula "position * 100 + segmentControlGap" helps us move the slider to the correct label
     based on the selected label ID. The term "position * 100" provides an equal step to switch between labels.
     The "segmentControlGap" is also calculated because there is a gap between labels. */
  transform: ${({ position }) =>
    `translateX(${position * 100}%) translateX(${
      position * segmentControlGap
    }px)`};
  position: absolute;
  transition: transform 0.4s ease;
  border-radius: 2px;
  box-shadow: 0 0 4px 0 rgb(66 68 90 / 10%);
  width: -webkit-fill-available;
  z-index: 1;
`;

export const SegmentedControlContainer = styled.div`
  position: relative;

  /* Keep the slide and label z-indexes below from escaping into the page, where
     they would paint over overlays such as an open dropdown. */
  isolation: isolate;
  background: transparent;
  border-radius: 4px;
  display: flex;
  align-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: ${getColor('grey-light-50')};
    mix-blend-mode: multiply;
    border-radius: inherit;
    pointer-events: none;
    z-index: 0;
  }
`;

export const SegmentedControlLabel = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  text-align: center;
  user-select: none;
  z-index: 2;
  cursor: pointer;
  font-size: ${getFontSize(14)};
  line-height: ${getLineHeight(14)};

  /* move all SegmentedControl labels above the SegmentedControlSlide */
  & span {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
  }
`;

export const SegmentedControlGroup = styled.fieldset`
  position: relative;
  z-index: 1;

  /* The sliding pill takes its width and its step from the first segment, so
     every segment has to be the same width. Grid tracks are equal at any
     container width; flex: 1 only equalises when there is free space to share,
     which a content-sized control does not have. */
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: ${segmentControlGap}px;
  border: none;
  padding: 0;
  width: 100%;
`;
